module.exports = __webpack_public_path__ + "img/Bitecla-logo2.f2735c6d.svg";